import { useQuery } from "@tanstack/react-query";
import { api, ApiError } from "./api";

export interface Folder {
  id: string;
  name: string;
  description: string;
  instructions: string;
  created_at: string;
}

export interface Entry {
  name: string;
  path: string;
  type: "file" | "dir";
  size: number;
  modified: string;
  mime: string | null;
}

export function useFolders() {
  return useQuery({ queryKey: ["folders"], queryFn: () => api.get<Folder[]>("/api/folders"), staleTime: 30_000 });
}

export function folderFileUrl(folderId: string, path: string, download = false) {
  return `/api/folders/${folderId}/file?path=${encodeURIComponent(path)}${download ? "&download=true" : ""}`;
}

export function uploadToFolder(folderId: string, dir: string, file: File, name?: string): Promise<Entry> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `/api/folders/${folderId}/upload?path=${encodeURIComponent(dir)}`);
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve(JSON.parse(xhr.responseText));
      else {
        let msg = xhr.statusText;
        try {
          msg = JSON.parse(xhr.responseText).detail ?? msg;
        } catch {
          /* not JSON */
        }
        reject(new ApiError(xhr.status, String(msg)));
      }
    };
    xhr.onerror = () => reject(new ApiError(0, "Upload failed"));
    const form = new FormData();
    form.append("file", file, name ?? file.name);
    xhr.send(form);
  });
}

const TEXT_EXT = /\.(txt|md|markdown|csv|tsv|json|jsonl|ya?ml|toml|ini|cfg|conf|log|xml|html?|css|m?js|tsx?|jsx|py|rb|go|rs|java|kt|c|h|cpp|hpp|cs|php|sh|bash|ps1|bat|sql|lua|swift|r|tex|rst|env|vue|svelte|gitignore|dockerfile)$/i;

export function isText(e: Entry): boolean {
  return (e.mime?.startsWith("text/") ?? false) || e.mime === "application/json" || TEXT_EXT.test(e.name);
}
